import jsLogo from "../assets/skills/jslogo.webp";
import dotnet from "../assets/skills/tailwindcsslogo.png";
import sanityLogo from "../assets/skills/dotnet.png";
import mongoLogo from "../assets/skills/mongodb.png";
import reactLogo from "../assets/skills/reactlogo.png";
import nodeLogo from "../assets/skills/nodejs.png";
import figmaLogo from "../assets/skills/Figma-logo.svg.png";
import CSharp from "../assets/skills/csharp.jpeg";
import tsLogo from "../assets/skills/Typescript_logo_2020.png";
import gcloud from "../assets/skills/gcloud.png";
import reactnative from "../assets/skills/react-native-1.svg";
import cplusplus from "../assets/skills/ISO_C++_Logo.png";
import sqllogo from "../assets/skills/sqllogo.jpeg";

const skills = [
  { src: jsLogo, alt: "JavaScript" },
  { src: dotnet, alt: "Dotnet" },
  { src: sanityLogo, alt: "Sanity" },
  { src: mongoLogo, alt: "MongoDB" },
  { src: reactLogo, alt: "React" },
  { src: nodeLogo, alt: "NodeJS" },
  { src: figmaLogo, alt: "Figma" },
  { src: CSharp, alt: "CSharp" },
  { src: gcloud, alt: "Google Cloud" },
  { src: reactnative, alt: "React Native" },
  { src: cplusplus, alt: "C++" },
  { src: sqllogo, alt: "SQL" },
];

const Skills = () => {
  return (
    <div
      id="skills"
      className="h-full  pb-10 md:pt-12 w-full bg-[#1E1E1E] flex flex-col items-center justify-start px-2"
    >
      <h1 className="text-[#FFCD29] px-4 text-3xl sm:text-4xl lg:text-5xl font-semibold mb-16 lg:-mt-5 lg:mb-44 text-center">
        <span className="text-white sm:w-full font-medium">
          i am pretty good in below
        </span>{" "}
        skills and technologies
      </h1>
      <div className="relative w-full max-w-2xl lg:max-w-6xl  bg-[#1E1E1E] p-2 sm:p-10 flex items-center justify-center">
        {/* Grid */}
        <div className="grid grid-cols-3 grid-rows-4 lg:grid-cols-4 lg:grid-rows-3 w-full h-full gap-10 sm:gap-32 lg:gap-36  transition-all">
          {skills.map((skill, i) => (
            <div key={i} className="flex items-center justify-center">
              <img
                src={skill.src}
                alt={skill.alt}
                className="max-h-14 max-w-20 sm:max-h-20 sm:max-w-28 object-contain"
              />
            </div>
          ))}
        </div>
        {/* Vertical lines */}
        {/* For 3 cols (mobile): 1/3, 2/3. For 4 cols (lg): 1/4, 2/4, 3/4 */}
        <div
          className="absolute top-0 left-1/3 w-0.5 h-full bg-[#FFCD29] opacity-70 lg:hidden"
          style={{ transform: "translateX(-1px)" }}
        />
        <div
          className="absolute top-0 left-2/3 w-0.5 h-full bg-[#FFCD29] opacity-70 lg:hidden"
          style={{ transform: "translateX(-1px)" }}
        />
        {/* Large screens: 4 cols */}
        <div
          className="hidden lg:block absolute top-0 left-1/4 w-0.5 h-full bg-[#FFCD29] opacity-70"
          style={{ transform: "translateX(-1px)" }}
        />
        <div
          className="hidden lg:block absolute top-0 left-2/4 w-0.5 h-full bg-[#FFCD29] opacity-70"
          style={{ transform: "translateX(-1px)" }}
        />
        <div
          className="hidden lg:block absolute top-0 left-3/4 w-0.5 h-full bg-[#FFCD29] opacity-70"
          style={{ transform: "translateX(-1px)" }}
        />
        {/* Horizontal lines */}
        {/* For 4 rows (mobile): 1/4, 2/4, 3/4. For 3 rows (lg): 1/3, 2/3 */}
        <div
          className="absolute left-0 top-1/4 h-0.5 w-full bg-[#FFCD29] opacity-70 lg:hidden"
          style={{ transform: "translateY(-1px)" }}
        />
        <div
          className="absolute left-0 top-2/4 h-0.5 w-full bg-[#FFCD29] opacity-70 lg:hidden"
          style={{ transform: "translateY(-1px)" }}
        />
        <div
          className="absolute left-0 top-3/4 h-0.5 w-full bg-[#FFCD29] opacity-70 lg:hidden"
          style={{ transform: "translateY(-1px)" }}
        />
        {/* Large screens: 3 rows */}
        <div
          className="hidden lg:block absolute left-0 top-1/3 h-0.5 w-full bg-[#FFCD29] opacity-70"
          style={{ transform: "translateY(-1px)" }}
        />
        <div
          className="hidden lg:block absolute left-0 top-2/3 h-0.5 w-full bg-[#FFCD29] opacity-70"
          style={{ transform: "translateY(-1px)" }}
        />
      </div>
    </div>
  );
};

export default Skills;
